import actions from "./actions";
import { getUserRole } from "helpers/utility";

const initState = {
  idToken: null,
  loginError: null,
  isLoading: false,
  role: 'Admin',// null,
  shopId: null,
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS: {
      return {
        idToken: action.token,
        isLoading: false,
        error: null,
      };
    }
    case actions.LOGIN_ERROR: {
      return {
        idToken: null,
        isLoading: false,
        error: action.error,
      };
    }
    case actions.LOGIN_PENDING: {
      return {
        isLoading: true,
      };
    }
    case actions.LOGOUT:
      return initState;
    case actions.SET_ROLE: {
      let { role } = getUserRole();
      if (!role) role = "testuser";
      console.log("set role", role);
      return {
        ...state,
        role: role
      };
    }
    default:
      return state;
  }
}
